<template>
  <div class="ui simple large sidebar fixed vertical inverted labeled menu left">
    <router-link to="/admin/booking" class="blue item" exact>
      <i class="calendar icon"></i>
      Booking Panel
    </router-link>
    <router-link to="/admin/reservations" class="blue item" exact>
      <i class="list icon"></i>
      Reservations
    </router-link>
    <router-link to="/admin/boats" class="blue item" v-if="canSeeBoats" exact>
      <i class="ship icon"></i>
      Boats
    </router-link>
    <router-link to="/admin/users" class="blue item" v-if="canSeeUsers" exact>
      <i class="users icon"></i>
      Users
    </router-link>
    <router-link to="/admin/reasons" class="blue item" v-if="canSeeReasons" exact>
      <i class="question icon"></i>
      Reasons
    </router-link>
    <router-link to="/admin/services" class="blue item" v-if="canSeeServices" exact>
      <i class="cocktail icon"></i>
      Services
    </router-link>
    <router-link to="/admin/vouchers" class="blue item" v-if="canSeeVouchers" exact>
      <i class="barcode icon"></i>
      Vouchers
    </router-link>
    <router-link to="/admin/settings" class="blue item" v-if="canSeeSettings" exact>
      <i class="edit icon"></i>
      Settings
    </router-link>
    <router-link to="/logout" class="blue item">
      <i class="sign out icon"></i>
      Logout
    </router-link>
  </div>
</template>

<script>
  //    import app from '../../../services/index'

  export default {
    data() {
      return {
//                baseVisible: false,
//                countryVisible: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      canSeeUsers() {
        return ['superAdmin'].indexOf(this.user.data.role) > -1
      },
      canSeeBoats() {
        return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1
      },
      canSeeSettings() {
        return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1
      },
      canSeeReasons() {
        return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1
      },
      canSeeVouchers() {
        return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1
      },
      canSeeServices() {
        return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1
      }
    },
    watch: {
      $route: function (route) {
        $('.ui.sidebar').sidebar('hide')
      }
    },
    mounted() {
      $('.ui.sidebar').sidebar({
//        context: '#app',
        transition: 'overlay',
      })
    },
    props: ['visible']
  }
</script>

<style scoped>
  .ui.sidebar {
    overflow: visible !important;
  }

  .center.aligned {
    text-align: center;
  }

  .nonfloating {
    margin-top: 5px !important;
    float: none !important;
  }
</style>



// WEBPACK FOOTER //
// Navigation.vue?0853630d